export const AdjustmentJobsActionTypes = {
    API_RESPONSE_SUCCESS: '@@adjustment-jobs/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@adjustment-jobs/API_RESPONSE_ERROR',
    LAUNCH_ADJUSTMENT_JOB: '@@adjustment-jobs/LAUNCH_ADJUSTMENT_JOB',
    GET_ADJUSTMENT_JOB_STATUS: '@@adjustment-jobs/GET_ADJUSTMENT_JOB_STATUS',
    STOP_ADJUSTMENT_JOB: '@@adjustment-jobs/STOP_ADJUSTMENT_JOB',
    RESTART_ADJUSTMENT_JOB: '@@adjustment-jobs/RESTART_ADJUSTMENT_JOB',
    GET_ALL_ADJUSTMENT_JOBS: '@@adjustment-jobs/GET_ALL_ADJUSTMENT_JOBS',
};
